module.exports = __webpack_public_path__ + "static/img/partner_18.4e6e877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_18.png
// module id = /Ibb
// module chunks = 0